import { literal, object, optional, type InferOutput } from "valibot"
import { InputBindingDevice } from "../InputBindingDevice.enum"

export const TouchClickInputBindingSchema = object({
  device: literal(InputBindingDevice.Touch),
  click: optional(literal(true)),
})

export type TouchClickInputBinding = InferOutput<typeof TouchClickInputBindingSchema>
